import React, {useState, useEffect, useMemo} from "react";
import { useForm } from "react-hook-form";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  advertisementeditms_path,
  get_ms_advertisements_withperform_path,
  get_ms_advertisement_path,
  put_ms_advertisement_path,
  apollo_setpoints_path,
  get_ms_campaign_path,
  apollo_account_platform_menu_path,
  get_ms_account_path,
} from "../../../atom/Apollo_links";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge"
import {Link, useLocation, useParams} from "react-router-dom";
import Fab from '@material-ui/core/Fab';
import {Chip, Tooltip} from "@material-ui/core";
import {MUISortOptions, MUIDataTableColumnDef} from "mui-datatables";
import {Backdrop, Grid} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import {
  menu_id_number,
  use_status_number,
  quasi_reservation_state_number,
  getQuasiReservationIconStyle,
} from "../../../atom/Apollo_styles";
import {
  StrOption,
  apollo_useStyles,
  options_ms_campaign_type,
  options_state_edit,
  options_state_edit_ms,
  valueToOption,
  Option,
  options_display_parent_archive_ads,
} from "../../../atom/Apollo_styles_Beta";
import {
  options_select_all,
} from "../../../atom/Apollo_Options";
import {APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import {ApolloRightDrawerContext, RightDrawer} from "../../../molecule/Apollo_RightDrawer";
import {
  ApolloBasicSelect,
} from "../../../molecule/Apollo_BaseItem";
import AdvertisementsEditMs from "./AdvertisementsEditMs";
import {Advertisement, AdvertisementUpdate, AdvertisementWithPerformance} from "./common/AdvertisementModel";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import AdAssetsDetail from "../../CRASSET/ms/AdAssetsDetail";
import {
  DATE_TIME_SUFFIX,
  AdProcessType,
  BLANK,
  options_ms_ad_denial_reason,
  options_ms_ad_review_state,
  RESULT_KBN,
  TARGET_REVIEW_STATUS_FOR_DISPLAY_DENIAL_REASON
} from "./common/CommonConst";
import {
  MSG,
  UNDER_SCORE,
  ALL,
  RESULT_SETPOINT_ERROR,
  TRACKING_POINT,
} from "../../../common/Apollo_CommonConst_Beta";
import {ROW_PER_PAGE_OPTIONS} from "../../../common/Apollo_CommonConst";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {ChartRawData} from "../../ADGROUP/ms/common/AdGroupModel";
import {ApolloDateRangePicker} from "../../../atom/Apollo_DateRangePicker";
import ApolloPerformance from "../../../molecule/Apollo_Performance";
import {LintChartColumnsPtn, LintChartStorageKey} from "../../SUMMARY/LineChart_Beta";
import {
  generateCsvHeader,
  generateSetPointColumns,
  generateColumns,
} from "../../SUMMARY/IndividualSummary";
import {toUtcIso8601str, valueToLabel, mergeOptions} from "../../../common/Apollo_CommonUtil_Beta";
import moment from "moment";
import {ApolloAxios, ApiResponse, isSuccessApi, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {parseInt} from "lodash";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {DataTableOptions, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {Bars} from "react-loader-spinner";
import {AdvertisementMsColumns, CsvData} from "../../../common/Apollo_CommonConst_Beta";
import Switch from '@material-ui/core/Switch';
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import {ApolloEventRecord, LogData, ItemList} from "../../../atom/Apollo_EventRecord";
import {cloneDeep} from "lodash";
import {
  APOLLO_PAGE_ID,
  DEFAULT_PAGE_SIZE,
  applyApolloSharedColumnSettings,
  createApolloSharedTableOptions,
  getApolloSharedCalendar,
  saveApolloSharedCalendar,
} from "../../../common/Apollo_LocalStorageSettings";
import Box from '@material-ui/core/Box';

const ApolloPerformanceMemo = React.memo(ApolloPerformance);

const apollo_AdStyles = makeStyles({
  previewModalMs: {
    overflow: "auto",
    height: "90%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  hiddenButtonMs: {
    opacity: 0,
    "&:hover": {
      opacity: 1
    },
  },
});

const AdvertisementsListMs: React.FC = () => {

  // usePrams
  const {
    accountgroupid,
    accountid,
    platformaccountid,
  } = useParams()

  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = parseInt(reqParams.get("campaignId") ?? "0");
  const adGroupId = parseInt(reqParams.get("adGroupId") ?? "0");
  const queryCampaignId = campaignId !== 0 ? `?campaignId=${campaignId}` : "";

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 25,
    breadId: 1,
    queries: ["", "", "", "", queryCampaignId],
    menu: {
      id: 2,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // styles
  const classes = apollo_useStyles();
  const adClasses = apollo_AdStyles();

  // useContext
  const {state: apolloContex} = React.useContext(ApolloContext);
  const displayParentArchiveFilterValue: number[] = apolloContex.filterInfo.displayParentArchiveFilterValue;
  const {data, setmsg} = React.useContext(ApolloMessage);

  // useState
  const [advertisements, setAdvertisements] = useState<AdvertisementWithPerformance[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const [chartRawDatas, setChartRawDatas] = useState<ChartRawData[]>([])

  const [reflectAt, setReflectAt] = useState<string>("")

  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
      
  const MIN_START_DATE = moment("2025-10-01");
  const DEFAULT_END_DATE = moment("2025-10-31");
  const LIMIT_DATE = moment("2025-09-30");

  // 条件判定
  const isBeforeLimit = moment().isSameOrBefore(LIMIT_DATE, "day");

  const defaultStartDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(MIN_START_DATE)
    : toUtcIso8601str(moment().startOf("month"));
  const defaultEndDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(DEFAULT_END_DATE)
    : toUtcIso8601str(moment().endOf("month"));
  const initialCalendar = getApolloSharedCalendar({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [startDate, setStartDate] = useState(initialCalendar.startDate);
  const [endDate, setEndDate] = useState(initialCalendar.endDate);
  const [previousStartDate, setPreviousStartDate] = useState(toUtcIso8601str(moment().startOf('month')))
  const [previousEndDate, setPreviousEndDate] = useState(toUtcIso8601str(moment().endOf('month')))
  const [previousChartRawData, setPreviousChartRawData] = useState<ChartRawData[]>([])
  const [isPreviousPeriodChecked, setIsPreviousPeriodChecked]= useState<boolean>(false)
  const [isPreviousPeriodDisabled, setIsPreviousPeriodDisabled]= useState<boolean>(false)
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);
  const [selectedValues, setSelectedValues] = useState<string[]>([ALL]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [isSetPointsLoaded, setIsSetPointsLoaded] = useState(false);
  const [isQuasiResvDisplay, setQuasiResvDisplay] = useState(false);
  // ステータストグル押下フラグ
  const [isPushStatusToggle, setIsPushStatusToggle] = useState<boolean>(false);
  const [advertisementId, setAdvertisementId] = useState<number>(0);

  // 期間変更比較
  type BeforeStartEndDate = {
    startDate: string,
    endDate: string,
  }
  const currentBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  const previousBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  // useForm
  const {
    control,
    errors,
  } = useForm({reValidateMode: 'onBlur'});

  const [columnFilterForStatus, setColumnFilterForStatus] = useState(options_state_edit.filter(elem => elem.value !== 3).map(elem => elem.label))
  const [columnFilterForDisplayParentArchive, setColumnFilterForDisplayParentArchive] = useState(
    options_display_parent_archive_ads.filter(elem => (displayParentArchiveFilterValue??[]).includes(elem.value)).map(elem => elem.label)
  )

  const initEditAdvertisement: AdvertisementWithPerformance = {
    adAccountId: 0,
    campaignId: 0,
    campaignName: "",
    campaignStatus: 0,
    adGroupId: 0,
    adGroupName: "",
    adGroupStatus: 0,
    creativeId: 0,
    creativeName: "",
    creativeStatus: 0,
    displayParentArchiveCode: 0,
    adAssetId: 0,
    adAssetName: "",
    trackingParam: "",
    trackingParamAdGroup: "",
    reviewStatus: 0,
    denialReason: 0,
    denialReasonDetail: "",
    createdDatetime: "",
    updatedDatetime: "",
    lastUpdatedUserId: "",
    lastUpdatedVer: "",
    achievement: {
      id: 0,
      cost: 0,
      imp: 0,
      click: 0,
    },
    assetImageUrl: "",
    campaignType: 0,
    cost: 0,
    imp: 0,
    click: 0,
    ctr: 0,
    cpc: 0,
    cpm: 0,
    trackingPointCvTotal: 0,
    trackingPointCvClickThrough: 0,
    trackingPointCvAssist: 0,
    trackingPointCpaTotal: 0,
    trackingPointCpaClickThrough: 0,
    trackingPointCpaAssist: 0,
    trackingPointCvrTotal: 0,
    trackingPointCvrClickThrough: 0,
    trackingPointCvrAssist: 0,
    trackingPointCvClickThroughSetPoints: [],
    trackingPointCvAssistSetPoints: [],
    trackingPointCpaClickThroughSetPoints: [],
    trackingPointCvrClickThroughSetPoints: [],
  }

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "creativeId",
    direction: 'desc',
  })
  const [numberOfRows, setNumberOfRows] = useState(5)
  const [processType, setProcessType] = useState("");

  // drawer
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const onHandleButtonClick = (event: any, index: number) => {
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
    setAdvertisementId(advertisements[index].creativeId);
    setSelectedIndex(index);
    setProcessType(event.currentTarget.id)
  }

  const [updateListCnt, setUpdateListCnt] = useState<number>(0)
  const listReloadFunc = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setUpdateListCnt(updateListCnt + 1)
  };

  // useEffect
  useEffect(() => {
    if (!isSetPointsLoaded && !isPushStatusToggle) return;

    setIsChartDataLoaded(false);
    const start = moment(startDate);
    const end = moment(endDate);
    const diffDays = end.diff(start, 'days') + 1;
    const previousStart = start.subtract(diffDays, 'days').format('YYYY-MM-DD');
    const previousEnd = end.subtract(diffDays, 'days').format('YYYY-MM-DD');
    setPreviousStartDate(previousStart);
    setPreviousEndDate(previousEnd);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });
    //広告一覧取得
    const fetchMsAds = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !advertisementId) return;
      setProgress(true);
      const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_advertisements_withperform_path}/${platformaccountid}/${campaignId}/${adGroupId}?startDate=${startDate}&endDate=${endDate}`
      await ApolloAxios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apolloContex.accesstoken}`,
          }
        }
      ).then((response) => {
        if (response.data.resultcode === RESULT_KBN.SUCCESS) {
          setAdvertisements(response.data.result.tableData)
          setChartRawDatas(response.data.result.chartData)
          setReflectAt(response.data.result.reflectAt)
          currentBeforeDate.current = {startDate: startDate, endDate: endDate,}
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
            }
          });
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
          }
        });
        alert(err);
      }).finally(() => {
        setProgress(false);
      });
    };

    const fetchPreviousMsAds = async () => {
      if (!isPreviousPeriodChecked && !isPushStatusToggle) return;
      if (startDate === previousBeforeDate.current.startDate && endDate === previousBeforeDate.current.endDate && !isPushStatusToggle && !advertisementId) return;
      setIsPreviousPeriodDisabled(true);
      const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_advertisements_withperform_path}/${platformaccountid}/${campaignId}/${adGroupId}?startDate=${previousStart}&endDate=${previousEnd}`
      await ApolloAxios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${apolloContex.accesstoken}`,
          }
        }
      ).then((response) => {
        if (response.data.resultcode === RESULT_KBN.SUCCESS) {
          setPreviousChartRawData(response.data.result.chartData)
          previousBeforeDate.current = {startDate: startDate, endDate: endDate,}
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
            }
          });
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
          }
        });
        alert(err);
      }).finally(() => {
        setIsPreviousPeriodDisabled(false);
      });
    };

    const fetchAll = async () => {
      await Promise.all(
        [fetchMsAds(), fetchPreviousMsAds()]
      ).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setProgress(false);
        setIsPushStatusToggle(false);
        setIsChartDataLoaded(true);
      });
    }
    fetchAll();
  }, [startDate, endDate, updateListCnt, isSetPointsLoaded, isPreviousPeriodChecked]);

  useEffect(() => {
    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${accountid}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`
            }
          });
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            if (data.setPointDeleteFlg === 0) {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
              }
              newSetPoints.push(option);
            } else {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}（削除済み）`,
              }
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
          }
        });
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsSetPointsLoaded(true);
      });
    }

    const fetchMsAdAccount = async () => {
          try {
            const urlAccountPlatformMenu = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_platform_menu_path}/${accountid}`;
            
            // 広告主アカウントメニュー情報取得
            const responseAccountPlatformMenu = await ApolloAxios.get(urlAccountPlatformMenu, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apolloContex.accesstoken}`,
              },
            })
            // menuIdが2(メール広告)かつuseStatusが1(利用可)のpfAccountIdを取得
            const targetEntry = responseAccountPlatformMenu.data.result.find(
              (entry: any) => entry.menuId === menu_id_number.MAIL && entry.useStatus === use_status_number.AVAILABLE
              );
              const platformAccountId = targetEntry?.pfAccountId;

            // MSアカウント詳細取得
            const urlGetMsAccount = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_account_path}/${apolloContex.current.accountGroupId}/${platformAccountId}`;
            const responseGetMsAccount = await ApolloAxios.get(urlGetMsAccount, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apolloContex.accesstoken}`,
              },
            })
            const quasiReservationStatus = responseGetMsAccount?.data.result.quasiReservationStatus;
    
            // 準予約ステータスが1の場合、準予約配信アイコン表示
            setQuasiResvDisplay(quasiReservationStatus === quasi_reservation_state_number.APPROVAL)
          } catch (err) {
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "error",
                message: `${MSG.ERROR_GET_ACCOUNT}${err.response?.data?.errmsg ?? BLANK}`
              }
            });
          }
        }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints(), fetchMsAdAccount()]
      ).finally(() => {
      })
    }

    fetchAll();

  }, []);

  const createOptions = () => {
    var local_options = [...options_select_all];

    if (advertisements && advertisements.length > 0) {
      advertisements.forEach((data, index) => {
        var opt: StrOption = {
          value: `${index}`,
          label: `${data.creativeId}${UNDER_SCORE}${data.creativeName}`,
        }
        local_options.push(opt);
      });
    }

    return local_options;
  }

  // listColumnConfig
  const adColumns: MUIDataTableColumnDef[] = [
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Tooltip title="広告編集" placement="bottom">
              <IconButton
                id={AdProcessType.edit}
                size='small'
                onClick={e => onHandleButtonClick(e, idx)}
              >
                <EditIcon className={classes.editIcon}/>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      name: "creativeId",
      label: "広告ID",
      options: {
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        filter: true,
        sort: true,
      }
    },
    {
      name: "creativeName",
      label: "広告名",
      options: {
        setCellProps: () => ({style: {minWidth: "11rem"}}),
        filter: true,
        sort: true,
        customBodyRenderLite: (idx: number) => {
          return (
            <React.Fragment>
              {advertisements[idx].creativeName}
            </React.Fragment>
          )
        },
      }
    },
    {
      name: "adGroupName",
      label: "広告グループ名",
      options: {
        setCellProps: () => ({style: {minWidth: "11rem"}}),
        filter: true,
        sort: true,
      }
    },
    {
      name: "campaignName",
      label: "キャンペーン名",
      options: {
        setCellProps: () => ({style: {minWidth: "11rem"}}),
        filter: true,
        sort: true,
      }
    },
    {
      name: "campaignType",
      label: "キャンペーン種別",
      options: {
        setCellProps: () => ({style: {minWidth: "11rem"}}),
        filter: true,
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_ms_campaign_type).label
        },
        customFilterListOptions: {
          render: (value: any) => valueToOption(value, options_ms_campaign_type).label
        },
        sort: true,
        customBodyRenderLite: (idx: number) => {
          return (
            <Chip
              label={
                <Typography variant="subtitle1">
                  {advertisements[idx] ? valueToOption(advertisements[idx].campaignType, options_ms_campaign_type).label : ""}
                </Typography>
              }
              style={
                advertisements[idx].campaignType == 1 ? {backgroundColor:  "blue", color: 'white', height: "100%"} : {backgroundColor: "red" , color: 'white', height: "100%"}
              }
            />
          )
        }
      }
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "trigger",
        display: !IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN)
          ? 'excluded'
          : true,
        setCellProps: () => ({style: {minWidth: "7rem", textAlign: "center"}}),
        customBodyRenderLite: (idx: number) => {
          const status = advertisements[idx].creativeStatus
          if (status === 6) return ("");
          return (
            <Switch
              checked={status === 2 ? true : false}
              onChange={(event, checked) => handleStatusChange(checked, advertisements[idx])}
              color="primary"
            ></Switch>
          );
        }
      } as any,
    },
    {
      name: "creativeStatus",
      label: "ステータス",
      options: {
        setCellProps: () => ({style: {minWidth: "7rem"}}),
        filter: true,
        filterList: columnFilterForStatus,
        sort: true,
        customBodyRender: (value: number) => {
          return value ? valueToOption(value, options_state_edit_ms).label : "";
        },
      },
    },
    {
      name: "displayParentArchive",
      label: "親キャンペーン・親広告グループのステータス",
      options: {
        filter: true,
        filterList: columnFilterForDisplayParentArchive,
        display: false,
        viewColumns: false,
        customBodyRender: (value: number) => valueToOption(value, options_display_parent_archive_ads).label,
      },
    },
    {
      name: "reviewStatus",
      label: "審査ステータス",
      options: {
        setCellProps: () => ({style: {minWidth: "7rem"}}),
        filter: true,
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_ms_ad_review_state).label
        },
        customFilterListOptions: {
          render: (value: any) => valueToOption(value, options_ms_ad_review_state).label
        },
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const value = advertisements[idx].reviewStatus
          const denialReason = advertisements[idx].denialReason
          return (
            <React.Fragment>
              {
                TARGET_REVIEW_STATUS_FOR_DISPLAY_DENIAL_REASON.includes(value) ?
                  <Tooltip title={valueToOption(denialReason, options_ms_ad_denial_reason).label}
                           placement="bottom">
                    <p>{valueToOption(value, options_ms_ad_review_state).label}</p>
                  </Tooltip> :
                  value ?
                    valueToOption(value, options_ms_ad_review_state).label : BLANK

              }

            </React.Fragment>
          )
        },
      },
    },
    {
      name: "assetImageUrl",
      label: "広告アセット情報",
      options: {
        setCellProps: () => ({style: {minWidth: "10rem", textAlign: "center"}}),
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <img
              src={value}
              style={{maxHeight: "80px"}}
            />
          );
        },
      }
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Button
              id={AdProcessType.preview}
              style={{width: "105px", margin: "15px"}}
              variant="contained"
              color="primary"
              onClick={e => onHandleButtonClick(e, idx)}
              className={classes.button}
            >
              プレビュー
            </Button>
          )
        },
      }
    },
    {
      name: "cost",
      label: "cost",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "imp",
      label: "imp",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "click",
      label: "click",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "ctr",
      label: "CTR",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "cpc",
      label: "平均CPC",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "cpm",
      label: "CPM",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvTotal",
      label: "CV(合計)",
      options: {
        filter: true,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvClickThrough",
      label: "ラストクリックCV(合計)",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvAssist",
      label: "アシストクリックCV(合計)",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvrTotal",
      label: "CVR(合計)",
      options: {
        filter: true,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrClickThrough",
      label: "ラストクリックCVR(合計)",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrAssist",
      label: "アシストクリックCVR(合計)",
      options: {
        filter: true,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCpaTotal",
      label: "CPA(合計)",
      options: {
        filter: true,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaClickThrough",
      label: "ラストクリックCPA(合計)",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCpaAssist",
      label: "アシストクリックCPA(合計)",
      options: {
        filter: true,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
  ];

  // 表で使用するパラメータをMemo化
  const chartRawDataMemo =  useMemo(() => chartRawDatas.map(value => value.performances), [selectedValues, chartRawDatas, previousChartRawData]);
  const previousChartRawDataMemo =  useMemo(() => previousChartRawData.map(value => value.performances), [selectedValues, chartRawDatas, previousChartRawData]);
  const columnsMemo =  useMemo(() => applyApolloSharedColumnSettings(
    generateColumns(adColumns, STORAGE_KEY.MS_ADVERTISEMENTS_LIST, setPoints, deletedSetPoints),
    {pageId: APOLLO_PAGE_ID.AD_MS, accountGroupId: accountgroupid, data: advertisements}
  ), [advertisements, drawerState, columnFilterForStatus, columnFilterForDisplayParentArchive, setPoints, deletedSetPoints, accountgroupid]);
  const optionsMemo: DataTableOptions = useMemo(() => createApolloSharedTableOptions({
    print: false,
    downloadOptions: {
      filename: `advertisements_mail_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, advertisements, setPoints, deletedSetPoints);
      return "\uFEFF" + buildHead(generateCsvHeader(AdvertisementMsColumns, setPoints, deletedSetPoints)) + buildBody(csvData);
    },
    sortOrder: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_LIST) ? undefined : sortOrder,
    rowsPerPage: numberOfRows,
    filterType: "multiselect",
    rowsPerPageOptions: ROW_PER_PAGE_OPTIONS.HOME_AND_MAIN_LEVELS,
    jumpToPage: true,
    elevation: 0,
    selectToolbarPlacement: "above",
    storageKey: STORAGE_KEY.MS_ADVERTISEMENTS_LIST,
    customToolbarSelect: () => undefined,
    onFilterChange: (changedColumn, filterList, type, changedColumnIndex) => {
      if (changedColumn === "creativeStatus") {
        setColumnFilterForStatus(filterList [changedColumnIndex]);
      } else if (changedColumn === "displayParentArchive") {
        setColumnFilterForDisplayParentArchive(filterList[changedColumnIndex]);
      }
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
  }, {
    pageId: APOLLO_PAGE_ID.AD_MS,
    accountGroupId: accountgroupid,
    columns: columnsMemo,
    defaultPageSize: DEFAULT_PAGE_SIZE,
  }), [advertisements, setPoints, deletedSetPoints, numberOfRows, columnsMemo, accountgroupid])

  useEffect(() => {
    saveApolloSharedCalendar(startDate, endDate);
  }, [startDate, endDate]);
  const setpointMemo =  useMemo(() => mergeOptions(setPoints, deletedSetPoints), [setPoints, deletedSetPoints]);
  const titleMemo = useMemo(() =>
    <React.Fragment>
      <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <Tooltip title="広告新規作成" placement="bottom">
          <span>
            <Fab
              size="small"
              color="primary"
              aria-label="add"
              style={{marginTop: "10px"}}
              onClick={async() => {
                setProgress(true);
                var isCampaignSpecified = false
                if (campaignId !== 0) {
                  const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaign_path}/${platformaccountid}/${campaignId}`
                  await ApolloAxios.get(
                    url,
                    {
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                      }
                    }
                  ).then((response) => {
                    if (response.data.resultcode !== 0) {
                      return Promise.reject({
                        open: true,
                        type: "error",
                        errmsg: `${"キャンペーン情報取得に失敗しました。"}${response?.data?.message ?? BLANK}`,
                      });
                    }

                    isCampaignSpecified = response.data.result.campaignType === 2

                  }).catch(err => {
                    setmsg({
                      type: "setMessage",
                      payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: `${"キャンペーン情報取得に失敗しました。"}${err?.errmsg ?? BLANK}`
                      }
                    });
                  });
                }
                setProgress(false);
                if (isCampaignSpecified) {
                  // エラーメッセージ表示
                  setmsg({
                    type: "setMessage",
                    payload: {
                      ...data,
                      open: true,
                      type: "error",
                      message: "リアルタイムメッセージSに紐づく広告は作成できません。",
                    },
                  });
                } else {
                  // 遷移先へ
                  window.location.href = `${advertisementeditms_path}${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}&adGroupId=${adGroupId}`;
                }
              }}
            >
              <AddIcon/>
            </Fab>
          </span>
        </Tooltip>
      </ApolloUserProfileAuth>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <p style={{fontSize: "20px"}}>広告別実績</p>
        {isQuasiResvDisplay && (
          <Chip
          label={
            <Typography variant="subtitle1">
              準予約配信
            </Typography>
          }
          variant="outlined"
          style={{...getQuasiReservationIconStyle(), marginLeft: 20}}
        />
        ) }
      </Box>
      <p style={{fontSize: "15px"}}>
        {
          "実績値取得日時: " +
          (
            reflectAt
              ? moment(reflectAt.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
              : BLANK
          )
        }
      </p>
    </React.Fragment>, [reflectAt, isQuasiResvDisplay])

  const advertisementInfo = React.useRef<AdvertisementWithPerformance>(initEditAdvertisement);
  const newStatusInfo = React.useRef(-1);
  const resultApi = React.useRef(-1);
  /** ステータス更新 */
  const handleStatusChange = async(checked: boolean, row: AdvertisementWithPerformance) => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    let isError = false;
    let advertisement: Advertisement = {
      adAccountId: 0,
      campaignId: 0,
      campaignName: "",
      campaignStatus: 0,
      adGroupId: 0,
      adGroupName: "",
      adGroupStatus: 0,
      creativeId: 0,
      creativeName: "",
      creativeStatus: 3,
      adAssetId: 0,
      adAssetName: "",
      trackingParam: "",
      trackingParamAdGroup: "",
      reviewStatus: 1,
      denialReason: 0,
      denialReasonDetail: "",
      createdDatetime: "",
      updatedDatetime: "",
      lastUpdatedUserId: "",
      lastUpdatedVer: "",
      achievement: {
        id: 0,
        cost: 0,
        imp: 0,
        click: 0,
      },
      assetImageUrl: "",
      campaignType: 1,
    }

    if (row.campaignType == 2) {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `${"リアルタイムメッセージSのキャンペーンに紐づく広告のステータスは変更できません。"}`,
        }
      });
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    }
    if (isError) return;

    const getUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_advertisement_path}/${platformaccountid}/${row.campaignId}/${row.adGroupId}/${row.creativeId}`
    await ApolloAxios.get(getUrl).then(response => {
      if (response.data.resultcode !== RESULT_KBN.SUCCESS) {
        isError = true;
        return Promise.reject({
          open: true,
          type: getResultType(response.data.resultcode),
          errmsg: `${MSG.ERROR_GET_ADGROUP}${response?.data?.message ?? BLANK}`,
        });
      }

      advertisement = {
        ...cloneDeep(response.data.result),
      }
    }).catch(err => {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    if (isError) {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
      return;
    };

    const newStatus = checked ? 2 : 3

    // 操作ログ出力(編集)
    advertisementInfo.current = row;
    newStatusInfo.current = newStatus;
    resultApi.current = 0;
    writeLog();

    const putUrl = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_advertisement_path}`
    const advertisementUpdate: AdvertisementUpdate = {
      ...cloneDeep(advertisement),
      adAccountId: platformaccountid,
      creativeStatus: newStatus,
      userId: apolloContex.userprofile.userId.toString(),
    }
    await ApolloAxios.put(putUrl, advertisementUpdate).then(response => {
      if (!isSuccessApi(response.data.resultcode)) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data?.message ?? "ステータス更新に失敗しました。"
          }
        });
        // 操作ログ(失敗)
        resultApi.current = 9;
        return;
      }
      // 操作ログ(成功)
      resultApi.current = 1;
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    // 操作ログ出力(結果)
    writeLog();

    if (resultApi.current === 1) {
      setIsPushStatusToggle(true);
      setUpdateListCnt(updateListCnt + 1)
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    }
  }

  /** 操作ログ出力 */
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(advertisementInfo.current.creativeStatus, options_state_edit_ms).label + "",
        afterValue: valueToOption(newStatusInfo.current, options_state_edit_ms).label + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: apolloContex.userprofile.userId,
      userName: apolloContex.userprofile.userName,
      accessToken: apolloContex.accesstoken,
      accountGroupID: apolloContex.current.accountGroupId,
      accountGroupName: apolloContex.current.accountGroupName,
      accountID: apolloContex.current.accountId,
      accountName: apolloContex.current.accountName,
      campaignID: advertisementInfo.current.campaignId + "",
      campaignName: advertisementInfo.current.campaignName + "",
      adGroupID: advertisementInfo.current.adGroupId + "",
      adGroupName: advertisementInfo.current.adGroupName + "",
      menu: "メール広告",
      displayName: "広告一覧画面",
      category: "広告",
      actionType: "更新",
      targetID: advertisementInfo.current.creativeId + "",
      targetName: advertisementInfo.current.creativeName + "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const [progress, setProgress] = useState(true);

  // render
  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      {selectedIndex === null ? <></> :
        <React.Fragment>
          <RightDrawer>
            <AdvertisementsController
              accountId={accountid}
              platformAccountId={platformaccountid}
              processType={processType}
              advertisements={advertisements}
              selectedIndex={selectedIndex}
              listReloadFunc={listReloadFunc}
            />
          </RightDrawer>
        </React.Fragment>
      }
      <CustomizedSnackbars/>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <Grid container spacing={1} justify="flex-end">
        <Grid item xs={4} md={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <ApolloDateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            {...(!isAuthorization && { startMinDate: new Date("2025-10-01T00:00:00") })}
          />
        </Grid>

        <Grid item xs={4} md={4}>
          <InputLabel id="graph-display-select">
            <Typography variant="caption">
            グラフ表示対象の選択
            </Typography>
          </InputLabel>
          <div>
            <ApolloBasicSelect
              id={"graph-display-select"}
              label=""
              isMulti={true}
              options={createOptions()}
              value={selectedValues}
              control={control}
              errors={errors}
              closeMenuOnSelect={false}
              setState={(e: any) => {
                const setVals = !e || e[e.length - 1].value === ALL ? [ALL] : e.filter((target: any) =>
                  target.value !== ALL
                ).map((target: any) => target.value);
                setSelectedValues(setVals)
              }}
              selectStyle={{ maxHeight: "70px", overflowY: "scroll"}}
            />
          </div>
        </Grid>

        <Grid item xs={4} md={4}>
        </Grid>
      </Grid>
      <ApolloPerformanceMemo
        startDate={startDate}
        endDate={endDate}
        previousStartDate={previousStartDate}
        previousEndDate={previousEndDate}
        dailyPerformanceData={chartRawDataMemo}
        previousDailyPerformanceData={previousChartRawDataMemo}
        selectedValues={selectedValues}
        data={advertisements}
        columns={columnsMemo}
        options={optionsMemo}
        storageKeyGraph1={LintChartStorageKey.MsAdvertisementsListGraph1}
        storageKeyGraph2={LintChartStorageKey.MsAdvertisementsListGraph2}
        fileName={`chart_advertisements_mail_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`}
        isPreviousPeriodChecked={isPreviousPeriodChecked}
        setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
        isPreviousPeriodDisabled={isPreviousPeriodDisabled}
        isChartDataLoaded={isChartDataLoaded}
        setPoints={setpointMemo}
        title={titleMemo}
        chartPtn={LintChartColumnsPtn.Ptn2}
      />
    </GenericTemplate>
  );
};

const AdvertisementsController: React.FC<{
  accountId: number,
  platformAccountId: number,
  processType: string,
  advertisements: any,
  selectedIndex: number,
  listReloadFunc: any,
}> = ({accountId, platformAccountId, processType, advertisements, selectedIndex, listReloadFunc,}) => {
  const advertisement = advertisements[selectedIndex]
  return [AdProcessType.edit].includes(processType) ?
    <AdvertisementsEditMs
      accountId={accountId}
      platformaccountId={platformAccountId}
      campaignId={advertisement.campaignId}
      adGroupId={advertisement.adGroupId}
      adId={advertisement.creativeId}
      processType={processType}
      listReloadFunc={listReloadFunc}
    /> : processType === AdProcessType.preview ?
      <AdAssetsDetail platformAccountId={platformAccountId}
                      assetId={advertisement.adAssetId}
                      options={{
                        trackingParam:
                          advertisement.trackingParam ?
                            advertisement.trackingParam :
                            advertisement.trackingParamAdGroup ?
                              advertisement.trackingParamAdGroup : BLANK
                      }}/> : <></>
}

const formatCsvData = (data: any[], tableData: AdvertisementWithPerformance[], setPoints: Option[], deletedSetPoints: Option[]): CsvData[] => {
  const dataList: CsvData[] = [];
  let mergedSetPoints = [...setPoints, ...deletedSetPoints];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.creativeId === v.data[1]);
      if (!values || values.length === 0) return;
      const d = values[0];
      const list: CsvData = {
        index: v.index,
        data: [
          d.creativeId,
          d.creativeName,
          d.adGroupName,
          d.campaignName,
          valueToLabel(d.campaignType, options_ms_campaign_type),
          valueToLabel(d.creativeStatus, options_state_edit_ms),
          valueToLabel(d.reviewStatus, options_ms_ad_review_state),
          d.adAssetId,
          `￥${d.cost}`,
          d.imp,
          d.click,
          `${(Math.floor((Math.round(d.ctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.cpc}`,
          `￥${d.cpm}`,
          d.trackingPointCvTotal,
          d.trackingPointCvClickThrough,
          ...generateSetPointColumns(d.trackingPointCvClickThroughSetPoints, TRACKING_POINT.CV_CLICK_THROUGH, mergedSetPoints),
          d.trackingPointCvAssist,
          ...generateSetPointColumns(d.trackingPointCvAssistSetPoints, TRACKING_POINT.CV_ASSIST, mergedSetPoints),
          `${(Math.floor((Math.round(d.trackingPointCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `${(Math.floor((Math.round(d.trackingPointCvrClickThrough * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          ...generateSetPointColumns(d.trackingPointCvrClickThroughSetPoints, TRACKING_POINT.CVR_CLICK_THROUGH, mergedSetPoints),
          `${(Math.floor((Math.round(d.trackingPointCvrAssist * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`,
          `￥${d.trackingPointCpaTotal}`,
          `￥${d.trackingPointCpaClickThrough}`,
          ...generateSetPointColumns(d.trackingPointCpaClickThroughSetPoints, TRACKING_POINT.CPA_CLICK_THROUGH, mergedSetPoints),
          `￥${d.trackingPointCpaAssist}`,
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default AdvertisementsListMs;
